import { Inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { STANDALONE_APP_CONFIGURATION, StandaloneAppConfiguration } from '@ftr/api-shared'
import { AppName, AppPlatform } from '@ftr/contracts/api/standalone-apps'
import { SimpleWindowRefService } from '@ftr/foundation'
import { AppPaths } from '@ftr/routing-paths'

@Injectable({
  providedIn: 'root',
})
export class AppDownloadService {
  constructor(
    private readonly router: Router,
    private readonly windowRefService: SimpleWindowRefService,
    @Inject(STANDALONE_APP_CONFIGURATION) readonly appConfig: StandaloneAppConfiguration,
  ) {}

  getStandaloneAppLink(): string {
    return this.router.serializeUrl(this.router.createUrlTree([AppPaths.StandaloneAppDownload]))
  }

  getDownloadUrl(appName: AppName, platform: AppPlatform): string {
    return `${this.appConfig.appDownloadUrl}${appName}?platform=${platform}`
  }

  openDownloadUrl(downloadUrl: string): void {
    this.windowRefService.open(downloadUrl, '_blank')
  }
}
